export default function baseApi(){
   return process.env.NEXT_PUBLIC_API_URL    
}
